import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { setSelectedSolutionIndex } from '../Slices/MatchingProductsSlice.ts';
import {
  AddToCartButton,
  MatchingProduct,
  SolutionComponent,
  SolutionPriceContainer,
} from '../Types/MatchingProducts.ts';
import { getComponentsForSelectedSolution } from './SelectedSolutionComponents.ts';
import {
  UpdateFitAssistantPriceAndATCForPDP,
  UpdateFitAssistantPriceAndATCForPDPExtranet,
} from './ProductPageUtils.tsx';

type SolutionsData = {
  solutionComponents: SolutionComponent[] | null;
  matchingProducts: MatchingProduct[] | null;
  solutionPriceContainer: SolutionPriceContainer[] | null;
  addToCartButton: AddToCartButton[] | null;
};

export const selectSolution = (
  index: number,
  { solutionComponents, matchingProducts, solutionPriceContainer, addToCartButton }: SolutionsData,
  dispatch: ThunkDispatch<unknown, unknown, UnknownAction>
): void => {
  dispatch(setSelectedSolutionIndex(index));

  if (window._THULEDATA?.isExtranet) {
    const components = getComponentsForSelectedSolution(solutionComponents, matchingProducts, index);
    UpdateFitAssistantPriceAndATCForPDPExtranet(components);
  } else if (solutionPriceContainer && addToCartButton) {
    UpdateFitAssistantPriceAndATCForPDP(solutionPriceContainer[index], addToCartButton[index]);
  }
};
